var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slinkContainerComp" }, [
    _c(
      "div",
      { staticClass: "slinkContainer posRel", on: { click: _vm.openDetail } },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c("div")
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "left20 is-size-4 top5" }, [
          _c("b", [_vm._v(":hello")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "is-size-5 top5" }, [
          _c("b", [_vm._v("SlinkPage: ")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "slinkContainerDisplayUrl top5 is-size-6" }, [
          _vm._v(
            "https://thelongulr.com/goes/here/home/asdfadsafda/adsfalfajsfadsfa/asdfafd"
          )
        ])
      ]),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-qrcode has-text-dark is-size-5" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2449e778", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2449e778","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlinkContainer.vue
// module id = null
// module chunks = 